import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IAssociateClinicResponse } from './index.type';

const useFetchAssociatedClinic = ({ pageNumber, searchTerm, clinicId }: { pageNumber?: number, searchTerm: string, clinicId?: string }) => {
const [associatedClinic, setAssociatedClinic] = React.useState<IAssociateClinicResponse>();

  const { loading: associatedClinicLoading, makeApiCall } = useApi({
   url: `/rtm/associated-clinic?page=${pageNumber}${clinicId ? `&clinicId=${clinicId}` : ''}${searchTerm ? `&search=${searchTerm}` : ''}`,
method: 'GET',

  });

  const getAssociatedClinic = async () => {
    const { response, error } = await makeApiCall<undefined,IAssociateClinicResponse>();

    if (response?.status) {
      setAssociatedClinic(response);
    } else {
      setAssociatedClinic(undefined);
    }

    if (error) {
      toast.error(error.msg || 'Something went wrong while fetching associated clinic. Please try again later');
    }
  };

  return {
    associatedClinic,
    getAssociatedClinic,
    associatedClinicLoading,
  };
};

export default useFetchAssociatedClinic;
